import { atom } from 'jotai'

import { brandGroupIdAtom } from '~/atoms'
import { exists } from '~/utils'

import {
  brandIdsAtom,
  columnCustomerAttributeIdsAtom,
  customerAttributeIdsAtom,
  questionIdsAtom,
} from './stateAtoms'

export const isTabulatableAtom = atom(
  (get) =>
    exists(get(brandGroupIdAtom)) &&
    0 < get(columnCustomerAttributeIdsAtom).length &&
    (0 < get(brandIdsAtom).length ||
      0 < get(questionIdsAtom).length ||
      0 < get(customerAttributeIdsAtom).length),
)
